import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { FiX, FiDownload } from "react-icons/fi";
import "../style/PdfPreviewModal.css";

const PdfPreviewModal = ({ open, onClose, pdfUrl, fileName }) => {
  useEffect(() => {
    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [pdfUrl]);

  const handleDownload = () => {
    if (!pdfUrl) return;

    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = fileName || "statement.pdf";
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  if (!open) return null;

  const modal = (
    <div
      className="pdf-modal-backdrop"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="pdf-modal" role="dialog" aria-modal="true" aria-label="PDF Preview">
        <div className="pdf-modal-header">
          <h3>PDF Preview</h3>
          <div className="pdf-modal-actions">
            <button
              type="button"
              className="pdf-btn pdf-btn--download"
              onClick={handleDownload}
              disabled={!pdfUrl}
              style={{
                height: 46,
                padding: "0 18px",
                borderRadius: 12,
              }}
            >
              <FiDownload size={16} />
              Download
            </button>
            <button
              type="button"
              className="pdf-modal-close"
              onClick={onClose}
              aria-label="Close"
            >
              <FiX size={18} />
            </button>
          </div>
        </div>

        <div className="pdf-modal-body">
          {!pdfUrl && (
            <div className="pdf-error">
              <p>No PDF available</p>
            </div>
          )}

          {pdfUrl && (
            <iframe
              src={pdfUrl}
              className="pdf-iframe"
              title="PDF Preview"
              frameBorder="0"
            />
          )}
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
};

export default PdfPreviewModal;
